import { render } from "./AutoCompleteUser.vue?vue&type=template&id=489a472a"
import script from "./AutoCompleteUser.ts?vue&type=script&lang=js"
export * from "./AutoCompleteUser.ts?vue&type=script&lang=js"

import exportComponent from "/Users/r.hutter/Resilio Sync/_Workspace/git/TitleTool-NG/titletool-nextgen-server/titletool-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__